import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { ButtonGroup } from 'react-bootstrap';
import { ToggleButton } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { InputGroup } from 'react-bootstrap';
import { Badge } from 'react-bootstrap';
import { UsersFetchAPI } from '../../api/Users';
import { ClientsFetchAPI } from '../../api/Clients';


import { ListGroup } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .mben-
───────────────────────────────────────────────────────── */
const MBEN_CSS = `
@keyframes mben-slide { from{opacity:0;transform:translateY(14px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }
@keyframes mben-item  { from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:translateY(0)} }

/* ── TRIGGER BUTTON ── */
.mben-trigger {
  display: inline-flex; align-items: center; gap: .4rem;
  padding: .42rem .95rem; border-radius: 9px;
  border: 1.5px solid rgba(27,58,107,.28);
  background: rgba(27,58,107,.07); color: #1B3A6B;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .79rem; font-weight: 700; cursor: pointer;
  transition: all .14s; white-space: nowrap;
}
.mben-trigger:hover { background: rgba(27,58,107,.14); border-color: #1B3A6B; }

/* ── MODAL ── */
.mben-dialog { max-width: 740px !important; }
.mben-dialog .modal-content {
  border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 24px 64px rgba(0,0,0,.18), 0 6px 16px rgba(0,0,0,.07) !important;
  overflow: hidden !important;
  animation: mben-slide .28s cubic-bezier(.34,1.56,.64,1) both !important;
}
.mben-dialog .modal-body { padding: 0 !important; }

/* ── HEADER ── */
.mben-head {
  display: flex; align-items: center; gap: .6rem;
  padding: 1rem 1.25rem .9rem;
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 100%);
}
.mben-head-ico {
  width: 34px; height: 34px; border-radius: 50%; flex-shrink: 0;
  background: rgba(255,255,255,.14); color: #fff;
  display: grid; place-items: center;
}
.mben-head-title {
  flex: 1; font-size: .92rem; font-weight: 700; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mben-head-sub { font-size: .7rem; color: rgba(255,255,255,.5); margin-top: 1px; }
.mben-head-close {
  width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0;
  border: 1.5px solid rgba(255,255,255,.22); background: rgba(255,255,255,.1);
  color: rgba(255,255,255,.8); display: grid; place-items: center;
  cursor: pointer; transition: all .14s;
}
.mben-head-close:hover { background: rgba(239,68,68,.35); border-color: rgba(239,68,68,.5); }

/* ── BODY ── */
.mben-body { padding: 1rem 1.25rem; display: flex; flex-direction: column; gap: .75rem; }

/* ── TABS (ToggleButton override) ── */
.mben-tabs {
  display: flex; gap: .4rem; padding: .55rem;
  background: rgba(0,0,0,.04); border-radius: 10px;
}
.mben-tabs .btn {
  flex: 1; padding: .48rem !important; border-radius: 8px !important;
  font-size: .79rem !important; font-weight: 600 !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  border: none !important; background: transparent !important; color: #6B7280 !important;
  transition: all .14s !important;
}
.mben-tabs .btn:hover { color: #1B3A6B !important; }
.mben-tabs .btn.active,
.mben-tabs .btn-check:checked + .btn {
  background: #fff !important; color: #1B3A6B !important;
  box-shadow: 0 1px 6px rgba(0,0,0,.1) !important; font-weight: 700 !important;
}

/* ── SEARCH ROW ── */
.mben-search-row {
  display: flex; align-items: center; gap: .5rem;
}
.mben-search-wrap { position: relative; flex: 1; }
.mben-search-ico {
  position: absolute; left: .7rem; top: 50%; transform: translateY(-50%);
  color: #9CA3AF; pointer-events: none; font-size: .9rem;
}
.mben-search-input {
  width: 100%; padding: .52rem .75rem .52rem 2.1rem;
  border: 1.5px solid rgba(0,0,0,.11) !important; border-radius: 9px !important;
  background: rgba(0,0,0,.03) !important; font-size: .82rem !important;
  color: #111827 !important; font-family: var(--font-sans,-apple-system,sans-serif) !important;
  transition: border-color .13s, box-shadow .13s !important; outline: none;
}
.mben-search-input:focus {
  border-color: #1B3A6B !important; box-shadow: 0 0 0 3px rgba(27,58,107,.09) !important;
  background: #fff !important;
}
.mben-search-input::placeholder { color: #B0B8C4 !important; }
.mben-sort-btn {
  display: inline-flex; align-items: center; gap: .3rem;
  padding: .5rem .85rem; border-radius: 9px; flex-shrink: 0;
  border: 1.5px solid rgba(0,0,0,.12); background: rgba(0,0,0,.04); color: #6B7280;
  font-size: .78rem; font-weight: 600; cursor: pointer; transition: all .13s;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mben-sort-btn:hover { border-color: #1B3A6B; color: #1B3A6B; }

/* ── LIST AREA ── */
.mben-list {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: .5rem; max-height: 380px;
  overflow-y: auto; overflow-x: hidden; /* ← evita scroll horizontal */
  scrollbar-width: thin; scrollbar-color: rgba(0,0,0,.1) transparent;
}
.mben-list::-webkit-scrollbar { width: 4px; }
.mben-list::-webkit-scrollbar-thumb { background: rgba(0,0,0,.12); border-radius: 4px; }

/* Normaliza ol/li de ListGroup dentro del grid */
.mben-list ol.list-group { margin: 0 !important; width: 100% !important; }
.mben-list .list-group-item {
  padding: 0 !important; border: none !important; background: transparent !important;
  width: 100% !important; display: flex !important; /* override Bootstrap display:block */
}

/* empty list */
.mben-list-empty {
  grid-column: 1 / -1; text-align: center; padding: 2rem;
  color: #B0B8C4; font-size: .82rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── BENEFICIARY CARD ── */
.mben-card {
  display: flex !important; align-items: center; gap: .65rem;
  padding: .7rem .85rem; border-radius: 11px;
  border: 1.5px solid rgba(0,0,0,.07); background: #F9FAFB;
  cursor: pointer; transition: all .14s;
  width: 100%; box-sizing: border-box; overflow: hidden;
  animation: mben-item .18s ease both;
}
.mben-card:hover {
  border-color: rgba(27,58,107,.3); background: rgba(27,58,107,.05);
}
.mben-avatar {
  width: 34px; height: 34px; border-radius: 50%; flex-shrink: 0;
  display: grid; place-items: center;
  font-size: .75rem; font-weight: 800; color: #fff;
}
.mben-card-body {
  flex: 1; min-width: 0;  /* ← clave: permite que el flex-child se encoja */
  overflow: hidden;
}
.mben-card-name {
  font-size: .81rem; font-weight: 700; color: #111827;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mben-card-sub {
  font-size: .7rem; color: #9CA3AF; margin-top: 2px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mben-select-ico { color: #C9CFD8; flex-shrink: 0; transition: color .14s; }
.mben-card:hover .mben-select-ico { color: #1B3A6B; }

/* ── HINT ── */
.mben-hint {
  display: flex; align-items: center; justify-content: center; gap: .3rem;
  font-size: .71rem; color: #B0B8C4;
  font-family: var(--font-sans,-apple-system,sans-serif); text-align: center;
}

/* ── FOOTER ── */
.mben-footer {
  display: flex; justify-content: flex-end;
  padding: .7rem 1.25rem .85rem;
  border-top: 1px solid rgba(0,0,0,.06);
}
.mben-cancel {
  display: inline-flex; align-items: center; gap: .35rem;
  padding: .5rem 1.1rem; border-radius: 9px; border: none;
  background: rgba(239,68,68,.08); color: #EF4444;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .81rem; font-weight: 600; cursor: pointer; transition: all .14s;
}
.mben-cancel:hover { background: #EF4444; color: #fff; }

@media(max-width: 760px) {
  .mben-dialog { max-width: calc(100vw - 1.5rem) !important; }
  .mben-list { grid-template-columns: 1fr; }
}
`;

if (typeof window !== 'undefined' && !document.getElementById('mben-styles')) {
  const el = document.createElement('style');
  el.id = 'mben-styles'; el.textContent = MBEN_CSS;
  document.head.appendChild(el);
}

/* ── avatar color por inicial ── */
const AVATAR_COLORS = ['#1B3A6B','#0891B2','#7C3AED','#DB2777','#059669','#D97706','#DC2626'];
const avatarColor = (name = '') => AVATAR_COLORS[(name.charCodeAt(0) || 0) % AVATAR_COLORS.length];
const avatarInitial = (name = '') => (name || '?').charAt(0).toUpperCase();

/* ── ICONS ── */
const IcoUser   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoSearch = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;
const IcoSortAZ = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="9" y2="18"/></svg>;
const IcoSortZA = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="9" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>;
const IcoChevR  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>;
const IcoX      = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
function Modalbeneficiary({ business, setclient_beneficiary, setuser_beneficiary, sethandlerloadData, setbeneficiary, getClientsByBusiness }) {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [showModal, setShowModal] = useState(false)
  const [clients, setClients] = useState([])
  const [searchedClients, setSearchedClients] = useState("")
  const [searchTerm, setSearchTerm] = useState('');
  const [deleteMode, setDeleteMode] = useState(false)
  const [orderSort, setOrderSort] = useState('asc')
  let token = localStorage.getItem("x-access-token")

  let user = localStorage.getItem('user');

  const [typeFilter, setTypeFilter] = useState('user_name')
  const [radioValue, setRadioValue] = useState('1');

  const getClients = async () => {
    setbeneficiary('')
    setuser_beneficiary({ user_id: "", user_name: "" })
    setclient_beneficiary({ client_id: "", client_name: "" })
    try {
      let clients_data = await getClientsByBusiness();
      let dataFilter = clients_data
      setTypeFilter("name")
      sortJSON(dataFilter, "name")
      setClients(dataFilter)
      setSearchedClients(dataFilter)
    } catch (err) { console.log(err) }
  }

  const getUserBybusiness = async () => {
    setbeneficiary('')
    setuser_beneficiary({ user_id: "", user_name: "" })
    setclient_beneficiary({ client_id: "", client_name: "" })
    try {
      const response = await UsersFetchAPI.getBusinessUser(business.id, token)
      let dataFilter = response.data.users.filter(({ lastName }) => lastName === "Descuento")
      setTypeFilter("user_name")
      sortJSON(dataFilter, "user_name")
      setClients(dataFilter)
      setSearchedClients(dataFilter)
    } catch (err) { console.log(err) }
  }

  function sortJSON(data, key) {
    return data.sort(function (a, b) {
      var x = a[key], y = b[key];
      if (orderSort === 'asc') { return ((x < y) ? -1 : ((x > y) ? 1 : 0)); }
      if (orderSort === 'desc') { return ((x > y) ? -1 : ((x < y) ? 1 : 0)); }
    });
  }

  const handleFilter = () => {
    if (orderSort === 'asc') { setOrderSort('desc') } else { setOrderSort('asc') }
    if (searchTerm === '') { sortJSON(clients, typeFilter) }
    else { sortJSON(filteredProducts, typeFilter) }
  }

  const handleSaveClient = (data) => {
    setOrderSort('asc')
    console.log(data)
    if (typeFilter == 'user_name') {
      let dataUser = { user_id: data.user_id, user_name: data.user_name }
      console.log(dataUser)
      setuser_beneficiary(dataUser)
      setbeneficiary(data.user_name)
    } else {
      let dataClient = { client_id: data.id, client_name: data.name }
      setclient_beneficiary(dataClient)
      setbeneficiary(data.name)
    }
    setShowModal(false)
    setSearchTerm('')
    sethandlerloadData(1)
  }

  const filteredProducts = useMemo(() => {
    if (searchTerm === '') { return clients }
    return searchedClients.filter(data => {
      if (data.name) {
        const nameMatch = data.name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
        return nameMatch;
      } else {
        const nameMatch = data.user_name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
        return nameMatch;
      }
    })
  }, [searchTerm, clients]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      {/* ── TRIGGER ── */}
      <button
        className="mben-trigger"
        onClick={() => (getUserBybusiness(), setShowModal(true))}
      >
        <IcoUser /> Buscar Beneficiario
      </button>

      <Modal
        className="bg-blur-sp"
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
        dialogClassName="mben-dialog"
      >
        <Modal.Body className="p-2">

          {/* ── HEADER NAVY ── */}
          <div className="mben-head">
            <div className="mben-head-ico"><IcoUser /></div>
            <div>
              <div className="mben-head-title">Beneficiario de descuento</div>
              <div className="mben-head-sub">
                {typeFilter === 'user_name' ? 'Colaboradores' : 'Clientes'} · {filteredProducts.length} resultado{filteredProducts.length !== 1 ? 's' : ''}
              </div>
            </div>
            <button className="mben-head-close" type="button" onClick={() => (setShowModal(false), setSearchTerm(''), setOrderSort('asc'))}>
              <IcoX />
            </button>
          </div>

          {/* ── BODY ── */}
          <div className="mben-body">

            {/* TABS — ToggleButton original con estilos custom */}
            <div className="mben-tabs">
              <ToggleButton
                key={1} id="radio-1" type="radio" variant="secondary"
                name="radio" value="1"
                checked={radioValue === "1"}
                onChange={e => setRadioValue(e.currentTarget.value)}
                onClick={() => getUserBybusiness()}
              >
                <IcoUser /> Colaborador
              </ToggleButton>
              <ToggleButton
                key={2} id="radio-2" type="radio" variant="secondary"
                name="radio" value="2"
                checked={radioValue === "2"}
                onChange={e => setRadioValue(e.currentTarget.value)}
                onClick={() => getClients()}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ marginRight: 3 }}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                Cliente
              </ToggleButton>
            </div>

            {/* SEARCH ROW */}
            <div className="mben-search-row">
              <div className="mben-search-wrap">
                <span className="mben-search-ico"><IcoSearch /></span>
                <input
                  spellCheck="false"
                  className="mben-search-input form-control"
                  type="text"
                  step="any"
                  placeholder={`Buscar ${typeFilter === 'name' ? 'cliente' : 'colaborador'}…`}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
              {/* sort Button — lógica handleFilter intacta */}
              <button className="mben-sort-btn" onClick={() => handleFilter()}>
                {orderSort === 'asc' ? <><IcoSortAZ /> A-Z</> : <><IcoSortZA /> Z-A</>}
              </button>
            </div>

            {/* LIST */}
            <div className={filteredProducts.length ? "mben-list" : "mben-list"}>
              {filteredProducts.length === 0 ? (
                <div className="mben-list-empty">
                  <div style={{ fontSize: '1.5rem', marginBottom: '.5rem' }}>🔍</div>
                  No se encontraron {typeFilter === 'name' ? 'clientes' : 'colaboradores'}
                </div>
              ) : (
                filteredProducts.map((data, i) => {
                  const displayName = typeFilter === 'user_name' ? data.user_name : data.name;
                  const color = avatarColor(displayName);
                  return (
                    <ListGroup as="ol" key={i} className="m-0 list-group">
                      <ListGroup.Item
                        as="li"
                        className="mben-card"
                        style={{ listStyle: 'none' }}
                        onClick={() => handleSaveClient(data)}
                      >
                        <div className="mben-avatar" style={{ background: color }}>
                          {avatarInitial(displayName)}
                        </div>
                        <div className="mben-card-body">
                          <div className="mben-card-name">
                            {typeFilter === 'user_name' ? data.user_name : data.name}
                          </div>
                          {typeFilter !== 'user_name' && (
                            <div className="mben-card-sub">
                              RUC: {data.ruc || '—'} · DV: {data.dv || '—'}
                            </div>
                          )}
                        </div>
                        <span className="mben-select-ico"><IcoChevR /></span>
                      </ListGroup.Item>
                    </ListGroup>
                  );
                })
              )}
            </div>

            {/* HINT */}
            <div className="mben-hint">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Seleccione un beneficiario para personalizar la factura
            </div>

          </div>

          {/* ── FOOTER ── */}
          <div className="mben-footer">
            <button
              className="mben-cancel"
              onClick={() => (setShowModal(false), setSearchTerm(''), setOrderSort('asc'))}
            >
              <IcoX /> Cancelar
            </button>
          </div>

          {/* preserva estructura original en display:none */}
          <div style={{ display: 'none' }}>
            <section className="flex-container">
              <div className="d-flex justify-content-center border-bottom-0">
                <h2 className="modal-title fw-bold fs-5"><i className="uil uil-users-alt" /> Beneficiario descuento</h2>
              </div>
              <span className="p-0 text-primary fw-bold">Seleccion de clientes</span>
              <Button className="" onClick={() => (getUserBybusiness(), setShowModal(true))}><i className="uil uil-chat-bubble-user" />Buscar Beneficiario</Button>
              <Button variant="outline-secondary" onClick={() => handleFilter()}>{orderSort === 'asc' ? <><i className="uil uil-sort-amount-down" /> A-Z</> : <><i className="uil uil-sort-amount-up" /> Z-A</>}</Button>
              <button className="btn bg-danger-subtle text-danger border-0 fw-bold" onClick={() => (setShowModal(false), setSearchTerm(''), setOrderSort('asc'))}>Cancelar</button>
            </section>
          </div>

        </Modal.Body>
      </Modal>

      {/* imports no-JSX preservados */}
      {void [ButtonGroup, Form, InputGroup, Badge, Container, Row, Col, useNavigate, useParams, Link, useEffect, deleteMode]}
    </>
  )
}

export default Modalbeneficiary